import useCameras from "./cameras/useCameras";
import useMap from "./map/useMap";

export default {
    useCameras,
    useMap
};